import axios from 'axios';

import { z } from 'zod/v4';
import { numericRegex } from '~/packages/common-frontend/constants';

// Constants
const ROUTE = '/login'; // POST

// Types
export const LoginFormValuesStruct = z.object({
  email: z.email({
    error: (iss) =>
      iss.input === undefined ? 'Required' : 'Must be a valid email',
  }),
  password: z
    .string({
      error: (iss) => (iss.input === undefined ? 'Required' : 'Invalid input.'),
    })
    .regex(numericRegex, { message: 'One number required' })
    .min(8, { message: 'Minimum 8 characters required' }),
});
export type LoginFormValues = z.infer<typeof LoginFormValuesStruct>;

// Exports
export const loginRequest = async (formValues: LoginFormValues) => {
  await axios.post(ROUTE, formValues, {
    headers: { 'Content-Type': 'application/json' },
  });
};
